import { Headline } from './Headline'
import { Arrow } from './Arrow'
import { Container } from './Container'
import { Column, Grid } from './Grid'
import { useQuery } from '@/utils/url'
import { useSelector, useDispatch } from 'react-redux'
import { setCouponIfAvailable } from '@/store/actions/checkout'
import { Button } from '@/components/controls/Button'
import { useBetterMediaQuery } from '@/hooks/BetterMediaQuery'
import { useEffect } from 'react'

export function CTADark() {
  const checkoutLink = useQuery('/checkout', { type: 'productivity-course' })
  const checkoutState = useSelector((state) => state.checkout)
  const sm = useBetterMediaQuery('(min-width: 768px)')
  const dispatch = useDispatch()

  useEffect(() => {
    const getCouponAction = async () => {
      const action = await setCouponIfAvailable()
      dispatch(action)
    }
    getCouponAction()
  }, [])

  return (
    <section id="cta">
      <Container withPattern>
        <Grid className="pt-[40px] pb-[90px] md:py-[90px] bg-[#202D3A] rounded-[15px] flex-col md:flex-row relative">
          <Column className="md:w-[60%] px-[40px] md:pl-[90px]">
            <Headline tag="h2" color='white' className="text-[40px] md:text-[56px] leading-[1.1] mb-[50px]">Ready for <em className='font-accent font--primary font-thin text-[48px] md:text-[60px]'>Scientific</em><br/> Productivity?</Headline>
            <div className="flex cursor-pointer absolute bottom-0 left-0 w-full md:relative md:w-auto mb-[30px] mx-[30px] md:mx-0">
              {checkoutState.coupon.available && checkoutState.coupon.finalPrice && checkoutState.coupon.initialPrice &&
                <Button href={checkoutLink} type="primary" chevron={true} noWrap={true} fullWidth={sm ? true : false} maxWidth={sm ? 350 : null} uppercase={false}><span className="text-[18px]">Get Instant Access <span className='line-through'>${checkoutState.coupon.initialPrice}</span> ${checkoutState.coupon.finalPrice}</span><Arrow className="ml-[16px] rotate-[-45deg]"/></Button>
              }
              {!checkoutState.coupon.available &&
                <Button href={checkoutLink} type="primary" chevron={true} noWrap={true} fullWidth={sm ? true : false} maxWidth={sm ? 350 : null} uppercase={false}><span className="text-[18px]">Get Instant Access $97</span></Button>
              }
            </div>
          </Column>
          <Column className="md:w-[40%] px-[46px] md:px-0">
            <div className="flex flex-col md:flex-row w-full mb-[30px]">
              <div className="flex md:w-[50%] mb-[30px] md:mb-0">
                <span className='text-[40px] font-thin leading-[1] text-[#BCA36B] mr-[24px] w-[28px]'>
                  5
                </span>
                <span className='leading-[1.2] font-thin font--primary text-[18px]'>
                  in depth <br/>
                  chapters
                </span>
              </div>
              <div className="flex md:w-[50%]">
                <span className='text-[40px] font-thin leading-[1] text-[#BCA36B] mr-[24px]'>
                  +
                </span>
                <span className='leading-[1.2] font-thin font--primary text-[18px]'>
                  lifetime <br/>
                  access
                </span>
              </div>
            </div>
            <div className="flex flex-col md:flex-row w-full mb-[30px]">
              <div className="flex md:w-[50%] mb-[30px] md:mb-0">
                <span className='text-[40px] font-thin leading-[1] text-[#BCA36B] mr-[24px] w-[28px]'>
                  5
                </span>
                <span className='leading-[1.2] font-thin font--primary text-[18px]'>
                  practical <br/>
                  worksheets
                </span>
              </div>
              <div className="flex md:w-[50%]">
                <span className='text-[40px] font-thin leading-[1] text-[#BCA36B] mr-[24px]'>
                  +
                </span>
                <span className='leading-[1.2] font-thin font--primary text-[18px]'>
                  ongoing <br/>
                  updates
                </span>
              </div>
            </div>
            <div className="flex flex-col md:flex-row w-full mb-[30px]">
              <div className="flex md:w-[50%] mb-[30px] md:mb-0">
                <span className='text-[40px] font-thin leading-[1] text-[#BCA36B] mr-[22px] md:mr-[24px]'>
                  2
                </span>
                <span className='leading-[1.2] font-thin font--primary text-[18px]'>
                  hours of video <br/>
                  training content
                </span>
              </div>
            </div>
          </Column>
        </Grid>
      </Container>
    </section>
  )
}
